<template>
  <div id="app">
    <div id="gBackground"></div>
    <div id="blured" :style="{ opacity: (!animationSwitch ? 1 : 0) }"></div>

    <transition name="fade" mode="out-in">
      <router-view v-if="!animationSwitch"/>
    </transition>

    <BigLogo v-if="animationSwitch" />
  </div>
</template>

<script>
  const delay = ms => new Promise(res => setTimeout(res, ms));
  import BigLogo from './views/bigLogo.vue';

  export default {
    name: "App",
    title: "Nethanzêl",
    components: {
      BigLogo
    },

    data() {
      return {
        animationSwitch: true,
        anglePositions: [180, 270, 360, 450, 540, 630, 720]
      }
    },

    mounted() {
      window.addEventListener("load", () => {
        let rotate = document.getElementById("gBackground");
        if(rotate) {
          rotate.style.transition = "transform 1.5s, opacity .8s ease";
        }
        this.InitAnimation();

        setTimeout(() => this.animationSwitch = false, 5250);
      });
    },

    methods: {
      async InitAnimation() {
        let rotate = document.getElementById("gBackground");
        let bigLogo = document.getElementById("bigLogo");

        if(rotate != null) {
          await delay(500);
          rotate.style.opacity = "1";
          rotate.style.transform = `rotate(${1080}deg)`;

          await delay(1000);

          bigLogo.style.opacity = "1";

          await delay(3000);
          bigLogo.classList.add("animateZoom");
          rotate.style.transition = "transform 1s";
          rotate.style.transform = `rotate(${this.anglePositions[this.getRandom(0, this.anglePositions.length)]}deg)`;
        }
      },
      getRandom (min, max) {
        return Math.floor(Math.random() * (max - min) + min);
      }
    }
  }
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Carme&display=swap');

* {
  color: #fff;
  padding: 0;
  margin: 0;
  font-family: 'Carme';
  letter-spacing: 1px;
}

#app {
  text-align: center;
  margin: 0 auto;
  max-width: 1700px;
}

h1, h2, p, span {
  cursor: default;
  pointer-events: none;
}

#gBackground {
  width: 300%;
  position: fixed;
  display: flex;
  z-index: -20;
  background: linear-gradient(-90deg, #fff 50%, #000 50%);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  transform-origin: center;
  transition: transform 1.5s, opacity .2s ease;
  overflow: hidden;
  top: -9998px;
  bottom: -9998px;
  left: -9998px;
  right: -9998px;
  margin: auto;
  opacity: 0;
}

#blured {
  position: fixed;
  z-index: -10;
  height: auto;
  min-height: 100%;
  width: 100vw;
  -webkit-backdrop-filter: blur(6.2px);
  backdrop-filter: blur(6.2px);
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 1s;
  top: 0;
  left: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: .6s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

</style>